module.exports = __webpack_public_path__ + "static/media/21.364d0e9f.png";